<template>
  <v-card color="grey lighten-4">
    <v-form @submit.prevent="submitEditDocket()" ref="editDocketForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header
            :title="'Edit'"
            :details="`${docket.externalRef} (${docket.id})` || docket.id"
            closeButton
            @close="$emit('close')"
          ></dialog-header>
          <v-flex xs12 sm4>
            <v-autocomplete
              label="Sub-Contractor"
              :color="primaryNeutral"
              :items="filteredContractors"
              v-model="contractorId"
              item-text="name"
              item-value="id"
              :loading="loadingContractors"
              :prepend-icon="$store.state.global.pages.contractor.icon"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              :rules="vehicleRules"
              v-model="vehicleId"
              label="* Vehicle"
              :loading="loading"
              :items="filteredVehicles"
              item-text="vehicleName_vehicleType"
              item-value="id"
              :prepend-icon="$store.state.global.pages.vehicle.icon"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              :rules="driverRules"
              v-model="driverId"
              label="* Driver"
              :loading="loading"
              :items="filteredDrivers"
              item-text="driverName_contractorName"
              item-value="id"
              :prepend-icon="$store.state.global.pages.driver.icon"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm4>
            <v-autocomplete
              :rules="siteRules"
              v-model="siteId"
              label="* Site"
              :loading="loading"
              :items="sites"
              item-text="name"
              item-value="id"
              :prepend-icon="$store.state.global.pages.site.icon"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm4>
            <date-picker-wrapper
              v-model="editedDocket.date"
              :rules="dateRules"
              label="* Docket Date"
              color="indigo"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm4>
            <date-picker-wrapper
              v-model="editedDocket.dateReceived"
              :rules="dateRules"
              label="* Date Received"
              color="indigo"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              @keydown.enter.prevent="preventDefault()"
              label="* Billing Period"
              color="indigo"
              prepend-icon="date_range"
              :items="allBillingPeriods"
              v-model="editedDocket.billingPeriod"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="insert_drive_file"
              v-model="editedDocket.externalRef"
              label="* Reference"
              :loading="loading"
              :rules="externalRefRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="note"
              v-model="editedDocket.notes"
              label="Notes"
              :loading="loading"
              :rules="notesRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 class="grey--text">
            <v-switch
              :color="$store.state.global.pages.docket.color"
              v-model="editedDocket.useAltRate"
              label="Use Alt Rate"
            ></v-switch>
          </v-flex>
          <card-divider-header></card-divider-header>
          <template v-if="!!Object.keys(editedDocket).length">
            <v-flex xs12 class="pb-1 flex-container-space-between">
              <div class="grey--text">Entered by: {{editedDocket.createdBy.name}}</div>
              <div class="grey--text">
                <time-ago :time="editedDocket.createdAt" needsParse created></time-ago>
              </div>
            </v-flex>
            <v-flex xs12 class="pb-2 flex-container-space-between">
              <div class="grey--text">Updated by: {{editedDocket.updatedBy.name}}</div>
              <div class="grey--text">
                <time-ago :time="editedDocket.updatedAt" needsParse updated></time-ago>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn color="grey darken-2" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'

// MIXINS
import DocketEditValidation from '@/services/validation/docketEditValidation'
import BillingPeriods from '@/services/mixins/billingPeriods'
import getSites from '@/services/mixins/getMasterFiles/getSites'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import FilterDriverVehicles from '@/services/mixins/filterDriverVehicles'
// import getProjects from '@/services/mixins/getMasterFiles/getProjects'
// import FilterContractorProjects from '@/services/mixins/filterContractorProjects'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import TimeAgo from '@/components/misc/timeAgo'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'

export default {
  mixins: [
    DocketEditValidation,
    BillingPeriods,
    getSites,
    getDrivers,
    getVehicles,
    //getProjects,
    getContractors,
    FilterDriverVehicles,
    // FilterContractorProjects,
  ],
  components: {
    DialogHeader,
    TimeAgo,
    DatePickerWrapper,
  },
  data() {
    return {
      siteId: null,
      contractorId: null,
      driverId: null,
      vehicleId: null,
      projectId: null,
      clonedDocket: Object.assign({}, this.docket),
      editedDocket: {},
      loading: false,
      useAltRate: false,
      prefix: 'editedDocket',
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      Object.assign(this.editedDocket, this.clonedDocket)
      this.close()
    },
    submitEditDocket() {
      if (!this.$refs.editDocketForm.validate()) {
        return
      }
      this.save()
    },
    getSiteObj() {
      var id = this.siteId
      var result = this.sites.filter((obj) => {
        return obj.id === id
      })
      this.site = result[0]
      this.projectId = result[0].projectId
    },
    save() {
      this.editedDocket.siteId = this.siteId
      this.editedDocket.vehicleId = this.vehicleId
      this.editedDocket.driverId = this.driverId
      this.editedDocket.contractorId = this.contractorId
      this.loading = true
      DocketService.updateDocket(this.editedDocket)
        .then((result) => {
          this.fetchTrips = true
          this.loading = false
          this.snack({
            color: 'green',
            text: `Docket was edited, ${result.data.result.updatedTrips} trips updated, ${result.data.result.failedTrips} trips failed to update,`,
          })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err.response)
          this.snack({ color: 'red', text: err.response.data.message })
        })
    },
  },
  computed: {
    currentProject() {
      return this.projects.filter((project) => {
        if (!!this.siteId) {
          const site = this.sites.filter((site) => {
            return site.id == this.siteId
          })[0]
          return project.id == site.projectId
        } else {
          return false
        }
        // const projectId = !!this.editedDocket.site ? this.editedDocket.site.projectId : null
      })[0]
    },
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    fetchTrips: Store.getSet({ store: 'trips', prop: 'fetchTrips' }),
    different() {
      if (!this._.isEqual(this.clonedDocket, this.editedDocket)) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.clonedDocket.driverId = this.clonedDocket.driver.id
    this.clonedDocket.siteId = this.clonedDocket.site.id
    this.clonedDocket.vehicleId = this.clonedDocket.vehicle.id
    this.clonedDocket.useAltRate = false
    this.projectId = this.clonedDocket.site.projectId
    this.contractorId = this.clonedDocket.vehicle.contractor.id
    this.driverId = this.clonedDocket.driverId
    this.vehicleId = this.clonedDocket.vehicleId
    this.siteId = this.clonedDocket.siteId
    Object.assign(this.editedDocket, this.clonedDocket)
  },
  props: {
    docket: Object,
  },
  watch: {
    siteId(val) {
      this.getSiteObj()
    },

    editedDocket(val) {
      this.projectId = val.site.projectId
      this.vehicleId = val.vehicleId
      this.driverId = val.driverId
    },
  },
}
</script>

<style>
</style>
